import React, { Component } from 'react'

export default class SortRecordText extends Component {
    onChangeItem = ({target}) => {
        this.props.onChangeItem(target.value);
    }
    render() {
        const {
            items,
            labelText,
            valueText,
            classAlign
        } = this.props
        const generateItems = (items) => {
            return items.map((item => {
                return (
                <option key={item.value} value={item.value}>{item.text}</option>
                )
            }))
        }
        return (
            <div>
                <div className={classAlign || "pull-right"}>
                    <label className="mr-sm-2 mt-2 mb-1 pull-left d-none d-sm-block">{labelText || "Sort"}</label>
                    <select className="form-control pull-left" style={{ width: 100, marginLeft: 3 }} onChange={this.onChangeItem} value={valueText}>
                        {generateItems(items)}
                    </select>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/views/controls/_SortRecordText.js